import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import {
  CustomDialogProps,
  SmartForm,
  SmartSubmit,
  SmartTextField,
} from "@nodeon/react-components";
import { useSnackbar } from "notistack";
import React from "react";
import { useTranslation } from "react-i18next";
import { ApiResponse, useEventTypeApi } from "~/api/GeneratedApi";

interface FormProps {
  name: string;
}

interface Props {
  initialValue?: string;
  onSubmitted?: (val: string) => void;
}

const EventTypeCreationDialog = ({
  handleClose,
  onSubmitted,
  initialValue,
}: CustomDialogProps & Props): JSX.Element => {
  const { addEventType } = useEventTypeApi();
  const { t } = useTranslation("event-type");
  const { enqueueSnackbar } = useSnackbar();

  const onSuccess = (data: FormProps, res: ApiResponse) => {
    enqueueSnackbar(t(`apiResponses:${res.resultKey}`), { variant: "success" });
    onSubmitted?.(data.name);
    handleClose?.();
  };

  const onSubmit = (data: FormProps) => {
    return addEventType({
      name: data.name,
    });
  };

  return (
    <Dialog open onClose={handleClose} aria-labelledby="form-dialog-title">
      <SmartForm<FormProps, ApiResponse>
        onSubmit={onSubmit}
        noGrid
        onSuccess={(data, res) => onSuccess(data, res)}
        formProps={{
          defaultValues: { name: initialValue ?? "" },
        }}
      >
        <DialogTitle id="form-dialog-title">{t("create-title")}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <SmartTextField<FormProps>
                fullWidth
                name="name"
                label={t("name")}
                required
                autoFocus
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t("general:cancel")}
          </Button>
          <SmartSubmit disabled={false}>{t("general:create")}</SmartSubmit>
        </DialogActions>
      </SmartForm>
    </Dialog>
  );
};

export default EventTypeCreationDialog;
